import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/news/page.tsx");
